import { duration } from "dayjs";
import dayjs from "./dayjs";
import Router from 'vue-router';

export default {
  timeLocalStorageKey: 'js404HappenedAt',
  handle(router: Router): void {
    const handleFirstTime = () => {
      localStorage.setItem(this.timeLocalStorageKey, dayjs().toISOString());
      location.reload();
    };

    const handleSubsequentTimes = () => {
      router.push({ name: 'SomethingWentWrong' });
    };

    if (!this.hasHappenedRecently) {
      handleFirstTime();
    } else {
      handleSubsequentTimes();
    }
  },
  get previousHappenedAt(): dayjs.Dayjs | null {
    const previous = localStorage.getItem(this.timeLocalStorageKey);
    if (!previous) return null;

    return dayjs.utc(
      previous,
      'YYYY-MM-DDTHH:mm:ss.SSS[Z]',
    );
  },
  get hasJustReloaded(): boolean {
    if (!this.previousHappenedAt) return false;
    return dayjs().isBefore(this.previousHappenedAt.add(duration(10, 'seconds')));
  },
  get hasHappenedRecently(): boolean {
    if (!this.previousHappenedAt) return false;
    return dayjs().isBefore(this.previousHappenedAt.add(duration(30, 'minutes')));
  },
};
